import CalendlyEvent from './CalendlyEvent.js';

export default CalendlyEvent;
